import React from 'react'

export function ManageInvoicesStyle() {
  return (
    <React.Fragment>
      <style jsx='true'>
      {`
        .customer-credit-account-table-container {
          display: flex;
          flex-direction: column;
          font-size: 1rem;
          justify-content: stretch;
        }

        .customer-credit-account-table {
          border-spacing: 0;
          border: solid 1px lightblue;
          width: 100%;
        }

        .customer-credit-account-table th, td {
          padding: 5px;
        }

        .pospro-action-btn.circle-delete {
          color: whitesmoke;
          padding: 5px 9px;
          border-radius: 50px;
          background-color: red;
          border: none;
        }
        .pospro-action-btn.circle-delete:hover {
          background-color: rgba(205, 0, 0, 1);
        }
      `}
      </style>
    </React.Fragment>
  )
}

export function PaymentHistoryStyle() {
  return (
    <React.Fragment>
      <style jsx='true'>
      {`
        .payment-history-table-container {
          display: flex;
          flex-direction: column;
          font-size: 1rem;
          justify-content: stretch;
          border: solid 1px lightblue;
          font-family: 'Courier New';
          width: 100%;
          box-sizing: border-box;
        }

        .payment-history-table-header {
          padding-left: 23px;
          padding-top: 20px;
        }

        .payment-history-table {
          border-spacing: 0;
          width: 100%;
          padding: 20px;
        }
        /*
        .payment-history-table th:nth-child(1), .payment-history-table td:nth-child(1) {
          width: 25%;
        }
        .payment-history-table th:nth-child(2), .payment-history-table td:nth-child(2) {
          width: 30%;
        }
        */

        .payment-history-table th, td {
          padding: 5px;
        }

        .font-courier { font-family: 'Courier New'; }
      `}
      </style>
    </React.Fragment>
  )
}

export function SOAStyle() {
  return (
    <React.Fragment>
      <style jsx='true'>
      {`
        /* Modify Parent Style Content Inner */
        /*
        #content-inner {
          background-color: whitesmoke
        }
        */

        .statement-of-account-header-container {
          padding: 10px
        }

        .statement-of-account-table-container {
          padding: 20px;
          border: solid 1px lightblue;
          background-color: white;
          display: flex;
          flex-direction: column;
          font-size: 1rem;
          font-family: 'Courier New';
          justify-content: stretch;
          width: 100%;
          box-sizing: border-box;
        }

        .statement-of-account-table th {
          padding: 5px;
          border-spacing: 0;
        }
        .statement-of-account-table td {
          padding: 0 5px;
          border-spacing: 0;
        }

        .amount-due-grand-total td, .payment-details-header td {
          padding-top: 20px;
          font-weight: bold;
        }

        .payments-total {
          font-weight: bold;
        }
      `}
      </style>
    </React.Fragment>
  )
}

export function CustomerCreditAccountInnerStyle() {
  return (
    <React.Fragment>
      <style jsx='true'>
      {`
        .customer-credit-account-container {
          display: flex;
          flex-direction: column;
          font-size: 1rem;
          justify-content: stretch;
        }

        .credit-account-title {
          margin: 10px 0;
          margin-right: 20px;
        }

        .tab-contents {
          display: flex;
          flex-direction: column;
          justify-content: stretch;
        }

        .tabs-button-container {
          display: flex;
        }
         .tab-button:hover {
          background-color: rgba(200, 200, 255, 0.2);
          color: black;
        }
        .tab-button:focus, .tab-button:active, .tab-button-active {
          background-color: lightblue;
          color: black;
        }
      `}
      </style>
    </React.Fragment>
  )
}
